var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionDndIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4686 8.17739C13.4686 7.47133 12.8963 6.89896 12.1902 6.89896C11.4842 6.89896 10.9118 7.47133 10.9118 8.17739C10.9118 8.88344 11.4842 9.45581 12.1902 9.45581C12.8963 9.45581 13.4686 8.88344 13.4686 8.17739Z",
    stroke: "#8493B2",
    strokeWidth: 2.55684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1392 8.17739C21.1392 7.47133 20.5668 6.89896 19.8607 6.89896C19.1547 6.89896 18.5823 7.47133 18.5823 8.17739C18.5823 8.88344 19.1547 9.45581 19.8607 9.45581C20.5668 9.45581 21.1392 8.88344 21.1392 8.17739Z",
    stroke: "#8493B2",
    strokeWidth: 2.55684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4686 15.8479C13.4686 15.1419 12.8963 14.5695 12.1902 14.5695C11.4842 14.5695 10.9118 15.1419 10.9118 15.8479C10.9118 16.554 11.4842 17.1263 12.1902 17.1263C12.8963 17.1263 13.4686 16.554 13.4686 15.8479Z",
    stroke: "#8493B2",
    strokeWidth: 2.55684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1392 15.8479C21.1392 15.1419 20.5668 14.5695 19.8607 14.5695C19.1547 14.5695 18.5823 15.1419 18.5823 15.8479C18.5823 16.554 19.1547 17.1263 19.8607 17.1263C20.5668 17.1263 21.1392 16.554 21.1392 15.8479Z",
    stroke: "#8493B2",
    strokeWidth: 2.55684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4686 23.5185C13.4686 22.8124 12.8963 22.24 12.1902 22.24C11.4842 22.24 10.9118 22.8124 10.9118 23.5185C10.9118 24.2245 11.4842 24.7969 12.1902 24.7969C12.8963 24.7969 13.4686 24.2245 13.4686 23.5185Z",
    stroke: "#8493B2",
    strokeWidth: 2.55684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1392 23.5185C21.1392 22.8124 20.5668 22.24 19.8607 22.24C19.1547 22.24 18.5823 22.8124 18.5823 23.5185C18.5823 24.2245 19.1547 24.7969 19.8607 24.7969C20.5668 24.7969 21.1392 24.2245 21.1392 23.5185Z",
    stroke: "#8493B2",
    strokeWidth: 2.55684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionDndIcon);
export default __webpack_public_path__ + "static/media/sectionDNDIcon.31f53983230931a6ea882a032007ca31.svg";
export { ForwardRef as ReactComponent };